import { useContext, useState } from 'react'

import { Box, Avatar, Text, Popover, Icon } from '@fairfashion/design-system'
import { useNavigate } from 'react-router-dom'

import { AuthContext } from '../../../../contexts/auth'
import { AvatarMenuItem } from '../AvatarMenuItem/avatar-menu-item.comp'

import * as Styles from './user-avatar.styles'

export const UserAvatar = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement>()

  const { signOut, user } = useContext(AuthContext)

  const userName = user?.user.name ?? ''

  const initials = userName
    ? userName
        .split(' ')
        .slice(0, 2)
        .map((n) => n[0])
        .join('')
    : ''

  const navigate = useNavigate()

  const closePopover = () => setAnchorEl(undefined)

  return (
    <Styles.UserAvatarWrapper
      gap={1}
      alignItems="center"
      width="100%"
      onClick={(e) => setAnchorEl(e.currentTarget)}
    >
      <Box>
        <Avatar size={40} backgroundColor="secondary" color="primary">
          {initials}
        </Avatar>
      </Box>
      <Box alignItems="center" flex={1} gap={1} justifyContent="space-between">
        <Text variant="p" size="normal" color="white">
          {userName}
        </Text>
        <Styles.UserAvatarIcon>
          <Icon name="arrow_down_s" size={24} color="secondary" />
        </Styles.UserAvatarIcon>
      </Box>
      <Popover
        anchorEl={anchorEl}
        onClose={closePopover}
        position="top-end"
        width="220px"
      >
        <Box direction="column">
          <AvatarMenuItem
            icon="building2"
            label="Minha Empresa"
            onClick={() => {
              navigate('/company')
              closePopover()
            }}
          />
          <AvatarMenuItem
            icon="question"
            label="F.A.Q."
            onClick={() => {
              navigate('/faq')
              closePopover()
            }}
          />
          <AvatarMenuItem
            icon="logout_box"
            label="Sair"
            onClick={() => signOut()}
          />
        </Box>
      </Popover>
    </Styles.UserAvatarWrapper>
  )
}
